import React, { useState, useEffect } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CSpinner,
  CAlert,
  CProgress,
  CProgressBar,
} from "@coreui/react";
import axios from "axios";
import { CIcon } from "@coreui/icons-react";
import { cilCloudDownload, cilSave } from "@coreui/icons";

// --- ШАБЛОН ПЕРВОЙ СТРАНИЦЫ (БОЛЬШОЙ ШТАМП) ---
const FRAME_TEMPLATE_FIRST = `
RECT 20.0 5.0 185.0 287.0 0.7
RECT 20.0 5.0 185.0 40.0 0.7
LINE 37.0 45.0 37.0 5.0 0.5
LINE 62.0 45.0 62.0 5.0 0.5
LINE 77.0 45.0 77.0 5.0 0.5
LINE 92.0 45.0 92.0 5.0 0.5
LINE 28.5 45.0 28.5 30.0 0.5
LINE 49.5 45.0 49.5 30.0 0.5
LINE 20.0 35.0 92.0 35.0 0.5
LINE 20.0 40.0 92.0 40.0 0.5
LINE 20.0 10.0 92.0 10.0 0.5
LINE 20.0 15.0 92.0 15.0 0.5
LINE 20.0 20.0 92.0 20.0 0.5
LINE 20.0 25.0 92.0 25.0 0.5
LINE 20.0 30.0 92.0 30.0 0.5
LINE 92.0 30.0 205.0 30.0 0.7
LINE 160.0 30.0 160.0 5.0 0.5
LINE 160.0 24.5 205.0 24.5 0.5
LINE 160.0 19.0 205.0 19.0 0.5
LINE 175.0 30.0 175.0 19.0 0.5
LINE 190.0 30.0 190.0 19.0 0.5
LINE 13.0 80.0 13.0 5.0 0.5
LINE 8.0 5.0 20.0 5.0 0.5
LINE 8.0 30.0 20.0 30.0 0.5
LINE 8.0 55.0 20.0 55.0 0.5
LINE 8.0 80.0 20.0 80.0 0.5
LINE 8.0 80.0 8.0 5.0 0.5
LINE 20.0 80.0 20.0 5.0 0.5
RECT 5.0 80.0 15.0 65.0 0.5
LINE 5.0 145.0 5.0 80.0 0.5
LINE 10.0 145.0 10.0 80.0 0.5
LINE 15.0 145.0 15.0 80.0 0.5
LINE 5.0 128.0 20.0 128.0 0.5
LINE 5.0 112.0 20.0 112.0 0.5
LINE 10.0 96.0 20.0 96.0 0.5
TEXT 21.8 31.8 7.0 L "Изм."
TEXT 29.0 31.8 7.0 L "Кол.уч"
TEXT 40.8 31.8 7.0 L "Лист"
TEXT 52.8 31.8 7.0 L "№ док"
TEXT 64.8 31.8 7.0 L "Подпись"
TEXT 81.8 31.8 7.0 L "Дата"
TEXT 21.3 27.0 7.0 L "Разработал"
TEXT 21.3 21.9 7.0 L "Проверил"
TEXT 21.3 11.8 7.0 L "Н. Контроль"
TEXT 163.6 26.2 7.0 L "Стадия"
TEXT 178.8 26.2 7.0 L "Лист"
TEXT 192.4 26.2 7.0 L "Листов"
TEXT 57.8 281.2 18.0 L "Ведомость дефектов и повреждений"
TEXT 145.0 35.2 18.0 C "-ТО-ВДП"
TEXT 122.0 17.2 10.0 C "Ведомость дефектов и повреждений"
`;

// --- ШАБЛОН ПОСЛЕДУЮЩИХ СТРАНИЦ (МАЛЕНЬКИЙ ШТАМП) ---
const FRAME_TEMPLATE_NEXT = `
RECT 20.0 5.0 185.0 287.0 0.7
LINE 37.3 20.2 37.3 5.0 0.5
LINE 61.9 20.2 61.9 5.0 0.5
LINE 76.7 20.2 76.7 5.0 0.5
LINE 92.3 20.2 92.3 5.0 0.5
LINE 28.5 20.2 28.5 5.2 0.5
LINE 49.5 20.2 49.5 5.2 0.5
LINE 20.0 10.2 92.0 10.2 0.5
LINE 20.0 15.2 92.0 15.2 0.5
LINE 13.0 80.0 13.0 5.0 0.5
LINE 8.0 5.0 20.0 5.0 0.5
LINE 8.0 30.0 20.0 30.0 0.5
LINE 8.0 55.0 20.0 55.0 0.5
LINE 8.0 80.0 20.0 80.0 0.5
LINE 8.0 80.0 8.0 5.0 0.5
LINE 20.0 80.0 20.0 5.0 0.5
RECT 5.0 80.0 15.0 65.0 0.5
LINE 5.0 145.0 5.0 80.0 0.5
LINE 10.0 145.0 10.0 80.0 0.5
LINE 15.0 145.0 15.0 80.0 0.5
LINE 5.0 128.0 20.0 128.0 0.5
LINE 5.0 112.0 20.0 112.0 0.5
LINE 10.0 96.0 20.0 96.0 0.5
TEXT 21.8 7.0 7.0 L "Изм."
TEXT 29.0 7.0 7.0 L "Кол.уч"
TEXT 40.8 7.0 7.0 L "Лист"
TEXT 52.8 7.0 7.0 L "№ док"
TEXT 64.8 7.0 7.0 L "Подпись"
TEXT 81.8 7.0 7.0 L "Дата"
TEXT 145.0 11.2 18.0 C "-ТО-ВДП"
TEXT 196.4 16.2 7.0 L "Лист"
LINE 20.4 20.2 205.2 20.2 0.5
LINE 194.0 20.2 194.0 4.6 0.5
LINE 193.8 12.2 205.0 12.2 0.5
`;

// --- ФУНКЦИЯ ОБРАБОТКИ ИЗОБРАЖЕНИЯ (РЕСАЙЗ + РАМКИ) ---
const processImageWithAnnotations = (blob, boxes = []) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(blob);

    img.onload = () => {
      const targetWidth = 4000;
      const scale = targetWidth / img.width;
      const targetHeight = Math.round(img.height * scale);

      const canvas = document.createElement("canvas");
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      if (boxes && boxes.length > 0) {
        ctx.lineWidth = 12;
        ctx.strokeStyle = "red";
        ctx.font = "bold 80px Arial";
        ctx.textBaseline = "top";

        boxes.forEach((box) => {
          const x = box.x * scale;
          const y = box.y * scale;
          const w = box.w * scale;
          const h = box.h * scale;

          ctx.beginPath();
          ctx.rect(x, y, w, h);
          ctx.stroke();

          if (box.label) {
            const text = box.label;
            const textX = x;
            const textY = y + 15;

            const textMetrics = ctx.measureText(text);
            const bgPadding = 10;
            const bgWidth = textMetrics.width + bgPadding * 2;
            const bgHeight = 80 + bgPadding * 2;

            ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
            ctx.fillRect(textX, textY, bgWidth, bgHeight);

            ctx.fillStyle = "red";
            ctx.fillText(text, textX + bgPadding, textY + bgPadding);
          }
        });
      }

      canvas.toBlob(
        async (newBlob) => {
          if (newBlob) {
            const buffer = await newBlob.arrayBuffer();
            resolve({
              data: new Uint8Array(buffer),
              height: targetHeight,
              width: targetWidth,
            });
          } else {
            reject(new Error("Ошибка конвертации canvas в Blob"));
          }
          URL.revokeObjectURL(img.src);
        },
        "image/jpeg",
        0.85,
      );
    };

    img.onerror = (err) => {
      URL.revokeObjectURL(img.src);
      reject(err);
    };
  });
};

const ReportNeuralModule = ({ visible, onClose, objectId, objectData }) => {
  const [wasmApi, setWasmApi] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressText, setProgressText] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const initWasm = async () => {
      try {
        const wasmModule =
          await import("../../../pkg/pdf_generator/pdf_generator");
        await wasmModule.default();
        setWasmApi(wasmModule);
      } catch (err) {
        console.error("WASM Error", err);
        setError("Ошибка загрузки модуля генерации PDF (WASM).");
      }
    };
    if (visible) {
      initWasm();
      setError(null);
      setPdfUrl(null);
      setIsGenerating(false);
      setProgress(0);
    }
  }, [visible]);

  // Функция для получения пути ДЛЯ СКАЧИВАНИЯ
  const getFullSizePath = (path) => {
    if (!path) return "";
    let cleanPath = path.replace(/\\/g, "/");
    const photoIndex = cleanPath.toLowerCase().indexOf("/фото/");
    if (photoIndex !== -1) {
      cleanPath = cleanPath.substring(photoIndex);
    } else {
      const thumbIndex = cleanPath.toLowerCase().indexOf("/thumbnails/");
      if (thumbIndex !== -1) {
        cleanPath = cleanPath.substring(thumbIndex);
      }
    }
    cleanPath = cleanPath.replace(/\/thumbnails\//i, "/");
    return cleanPath;
  };

  // ИСПРАВЛЕНИЕ 1: Функция, корректно обрабатывающая числа (например, 0), не превращая их в "-"
  const safeStr = (val) => {
    if (val === null || val === undefined) return "-";
    const textStr = String(val); // Безопасно переводим всё в строку, включая числа
    if (!textStr.trim()) return "-";

    return (
      textStr
        .replace(/"/g, "'") // Убираем двойные кавычки
        .replace(/;/g, "\n") // Меняем точку с запятой на перенос строки
        .replace(/\n/g, "\\n") // Экранируем переносы для WASM 
        .trim() || "-"
    );
  };

  const generateReport = async () => {
    if (!wasmApi) {
      setError("WASM модуль еще не загружен.");
      return;
    }

    if (!objectId) {
      setError("ID объекта не найден.");
      return;
    }

    setIsGenerating(true);
    setError(null);
    setPdfUrl(null);
    setProgress(0);
    setProgressText("Анализ структуры дефектов...");

    try {
      // 1. Получаем список конструкций (1 уровень)
      const firstLevelResponse = await axios.get(
        `/api/neural_network_module/${objectId}/tree-first-level/`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const constructions = Array.isArray(firstLevelResponse.data)
        ? firstLevelResponse.data
        : [];

      if (constructions.length === 0) {
        throw new Error(
          "Не найдено конструкций с дефектами для данного объекта.",
        );
      }

      let script = "# Generated Report\n";
      const imagesMap = {};
      const imageHeights = {};

      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = String(now.getFullYear()).slice(-2);
      const currentDate = `${month}.${year}`;

      // 2. Собираем плоский список всех дефектов для итерации
      let allDefectsToProcess = [];

      for (const construction of constructions) {
        const secondLevelResponse = await axios.get(
          `/api/neural_network_module/${objectId}/tree-second-level/`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { first_class_id: construction.ClassID },
          },
        );

        const defectTypes = Array.isArray(secondLevelResponse.data)
          ? secondLevelResponse.data
          : [];

        for (const defectType of defectTypes) {
          allDefectsToProcess.push({
            constructionName: construction.CName || construction.ClassName,
            firstClassId: construction.ClassID,
            defectTypeName: defectType.Cname || defectType.ClassName,
            secondClassId: defectType.ClassID,
          });
        }
      }

      const totalDefects = allDefectsToProcess.length;
      if (totalDefects === 0) {
        throw new Error("Конструкции найдены, но дефекты не обнаружены.");
      }

      // 3. Проходим по всем дефектам
      for (let i = 0; i < totalDefects; i++) {
        const item = allDefectsToProcess[i];
        const percent = Math.round(((i + 1) / totalDefects) * 90);
        setProgress(percent);
        setProgressText(
          `Обработка: ${item.defectTypeName} (${i + 1}/${totalDefects})`,
        );

        // Получаем сохраненные свойства дефекта из БД
        const propsResponse = await axios.get(
          `/api/neural_network_module/${objectId}/defect-properties/`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              first_class_id: item.firstClassId,
              second_class_id: item.secondClassId,
            },
          },
        );
        const defectProps =
          Array.isArray(propsResponse.data) && propsResponse.data.length > 0
            ? propsResponse.data[0]
            : {};
            
        // Вытаскиваем значения строго из полей (то, что сохранил пользователь чекбоксами)
        let char = defectProps.DefectCharacter || "";
        let category = defectProps.Category || "";
        let cause = defectProps.Cause || "";
        let rec = defectProps.Recommendation || "";
        let location = defectProps.Location || "";
        let quantitative = (defectProps.QuantitativeValue ?? defectProps.Quantitative) ?? "";

        // ПАРСИМ СЛОВАРЬ DC (CombinedTable) ТОЛЬКО для получения "Количественного показателя" и "Названия", если пусто.
        // Причины и рекомендации НЕ берем из DC, чтобы не вываливался весь справочник.
        if (defectProps.DC) {
          try {
            const parsedDc = JSON.parse(defectProps.DC);
            if (Array.isArray(parsedDc) && parsedDc.length > 0) {
              const firstItem = parsedDc[0];

              // Если пользователь не ввел характер дефекта, берем из справочника
              if (!char) char = firstItem.Name || "";
              
              // Если пользователь не ввел колич. показатель, берем из справочника
              if (quantitative === "") quantitative = firstItem.QuantitativeValue ?? "";
            }
          } catch (e) {
            console.warn("Ошибка парсинга DC в отчете", e);
          }
        }
            
        // Ищем фото (сначала конкретного дефекта, потом конструкции)
        let photoPath = null;
        try {
          const imgRes = await axios.get(
            `/api/neural_network_module/${objectId}/tree-images/`,
            {
              headers: { Authorization: `Bearer ${token}` },
              params: {
                first_class_id: item.firstClassId,
                second_class_id: item.secondClassId,
              },
            },
          );
          if (imgRes.data && imgRes.data.length > 0) {
            photoPath = imgRes.data[0].FilePath;
          }
        } catch (e) {
          console.warn(`Фото для дефекта не найдено, ищем общие фото...`);
        }

        if (!photoPath) {
          try {
            const imgRes = await axios.get(
              `/api/neural_network_module/${objectId}/tree-images/`,
              {
                headers: { Authorization: `Bearer ${token}` },
                params: { first_class_id: item.firstClassId },
              },
            );
            if (imgRes.data && imgRes.data.length > 0) {
              photoPath = imgRes.data[0].FilePath;
            }
          } catch (e) {
            console.warn(`Фото конструкции тоже не найдено.`, e);
          }
        }

        let imgKey = "";
        let imageRowHeight = 259; // Дефолтная высота исходника (в пикселях)

        if (photoPath && objectData?.LDoc) {
          const downloadPath = getFullSizePath(photoPath);
          const annotationPath = photoPath.replace(/[\\/]thumbnails[\\/]/gi, "\\");

          const fileName = downloadPath.split("/").pop();
          const cleanFileName = fileName.replace(/[^a-zA-Z0-9._-]/g, "_");
          const mapKey = `{${cleanFileName}_${item.secondClassId}}`;
          imgKey = mapKey;

          if (!imagesMap[mapKey]) {
            try {
              const imgBuffer = await axios.get(
                `/api/ldoc/${objectData.LDoc}/workdir/preview/?path=${encodeURIComponent(downloadPath)}`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                  responseType: "arraybuffer",
                },
              );

              if (imgBuffer.data && imgBuffer.data.byteLength > 0) {
                let boxesToDraw = [];
                try {
                  const annRes = await axios.get(
                    `/api/neural_network_module/${objectId}/tree-annotations/`,
                    {
                      params: {
                        image_path: annotationPath,
                        first_class_id: item.firstClassId,
                        slc_class_id: item.secondClassId,
                      },
                      headers: { Authorization: `Bearer ${token}` },
                    },
                  );

                  if (Array.isArray(annRes.data)) {
                    boxesToDraw = annRes.data.map((ann) => ({
                      x: ann.x1,
                      y: ann.y1,
                      w: ann.x2 - ann.x1,
                      h: ann.y2 - ann.y1,
                      label: defectProps.ClassName || item.defectTypeName,
                    }));
                  }
                } catch (annErr) {
                  console.warn("Не удалось получить аннотации для рисования", annErr);
                }

                const blob = new Blob([imgBuffer.data]);
                const processedImage = await processImageWithAnnotations(blob, boxesToDraw);

                imagesMap[mapKey] = processedImage.data;
                imageHeights[mapKey] = processedImage.height;
                imageRowHeight = processedImage.height;
              } else {
                imgKey = "";
              }
            } catch (e) {
              console.error(` - Ошибка обработки изображения:`, e);
              imgKey = "";
            }
          } else {
            if (imageHeights[mapKey]) {
              imageRowHeight = imageHeights[mapKey];
            }
          }
        }

        // Данные для текста
        const constrName = item.constructionName;
        const defName = defectProps.ClassName || item.defectTypeName;

        // =================================================================================
        // ЛОГИКА ОГРАНИЧЕНИЯ ВЫСОТЫ И ПРОПОРЦИЙ
        // =================================================================================

        const MAX_ROW_HEIGHT_UNITS = 320.0; // Максимальная высота строки в PDF 
        const BASE_SCALE = 0.1; 

        // 1. Считаем высоту, которая получилась бы при старом расчете
        let finalRowHeight = imageRowHeight / 10;
        let finalScaleX = BASE_SCALE;
        let finalScaleY = BASE_SCALE;

        // 2. Если высота превышает лимит — пересчитываем
        if (imgKey && finalRowHeight > MAX_ROW_HEIGHT_UNITS) {
          const ratio = MAX_ROW_HEIGHT_UNITS / finalRowHeight;

          // Устанавливаем высоту в лимит
          finalRowHeight = MAX_ROW_HEIGHT_UNITS;

          // Уменьшаем масштаб картинки пропорционально
          finalScaleX = BASE_SCALE * ratio;
          finalScaleY = BASE_SCALE * ratio;
        }

        // ИСПРАВЛЕНИЕ 2: Формируем контент таблицы, добавляем Количественный показатель
        let tableContent = "";
        tableContent += `Наименование конструкции:|${safeStr(constrName)};`;

        if (location) {
          tableContent += `Местоположение/Дефект:|${safeStr(location)} / ${safeStr(defName)};`;
        } else {
          tableContent += `Наименование дефекта:|${safeStr(defName)};`;
        }

        tableContent += `Характер дефекта:|${safeStr(char)};`;
        tableContent += `Категория технического состояния:|${safeStr(category)};`;

        if (imgKey) {
          // Вставляем рассчитанную высоту и масштабы (X и Y)
          tableContent += `[${finalRowHeight.toFixed(2)}px]{L:M}Фотография выявленного дефекта:|{L:B}IMG:${imgKey}:${finalScaleX.toFixed(5)}:${finalScaleY.toFixed(5)};`;
        } else {
          // Фиксированная высота для строки без фото
          tableContent += `[50px]{L:M}Фотография выявленного дефекта:|Фото отсутствует;`;
        }

        tableContent += `Возможные причины:|${safeStr(cause)};`;
        tableContent += `Рекомендуемый способ устранения:|${safeStr(rec)};`;
        tableContent += `Количественный показатель:|${safeStr(quantitative)}`;

        // =================================================================================

        let textYPosition;
        let tableYPosition;

        if (i === 0) {
          // ПЕРВАЯ СТРАНИЦА 
          textYPosition = 267.9;
          tableYPosition = 262.1;
        } else {
          // ВТОРАЯ И ПОСЛЕДУЮЩИЕ СТРАНИЦЫ
          textYPosition = 286.0;
          tableYPosition = 280.0;
        }

        // =================================================================================

        script += `PAGE A4\n`;

        if (i === 0) {
          script += FRAME_TEMPLATE_FIRST;
          script += `TEXT 80.1 26.5 7.0 L "${currentDate}"\n`;
          script += `TEXT 80.1 21.9 7.0 L "${currentDate}"\n`;
          script += `TEXT 80.1 11.5 7.0 L "${currentDate}"\n`;
          script += `TEXT 167.8 20.8 6.8 C "ТО"\n`;
          script += `TEXT 181.8 20.8 7.0 C "1"\n`;
          script += `TEXT 197.5 20.8 7.0 C "${totalDefects}"\n`;
        } else {
          script += FRAME_TEMPLATE_NEXT;
          script += `TEXT 199.0 8.0 7.0 C "${i + 1}"\n`;
        }

        script += `TEXT 196.5 ${textYPosition} 12.3 R "Таблица ${i + 1} - Дефект ${i + 1}"\n`;

        // ИСПРАВЛЕНО 3: 8 строк = 8 высот в массиве
        script += `TABLE 20.0 ${tableYPosition} 8 76.176,108.824 2,2,2,2,16,2,2,2 L "${tableContent}"\n`;
        script += "\n";
      }

      setProgress(98);
      setProgressText("Компиляция PDF файла...");

      setTimeout(() => {
        try {
          const pdfBytes = wasmApi.generate_pdf(script, imagesMap);
          const blob = new Blob([pdfBytes], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
          setProgress(100);
          setIsGenerating(false);
        } catch (e) {
          console.error("WASM Generation Error", e);
          setError("Ошибка внутри PDF генератора: " + e);
          setIsGenerating(false);
        }
      }, 100);
    } catch (err) {
      console.error("Report Generation Error", err);
      setError(err.message || "Неизвестная ошибка при подготовке отчета.");
      setIsGenerating(false);
    }
  };

  return (
    <CModal
      alignment="center"
      visible={visible}
      onClose={onClose}
      size="xl"
      fullscreen
    >
      <CModalHeader>
        <CModalTitle>Генерация отчета</CModalTitle>
      </CModalHeader>
      <CModalBody className="d-flex flex-column" style={{ height: "80vh" }}>
        <div className="mb-3 d-flex justify-content-between align-items-center bg-light p-2 rounded">
          <div className="d-flex gap-2 align-items-center">
            {/* <strong>Объект:</strong> {objectData?.Name} */}
          </div>
          <div>
            {!isGenerating && !pdfUrl && (
              <CButton color="primary" onClick={generateReport}>
                <CIcon icon={cilSave} className="me-2" />
                Сформировать отчет
              </CButton>
            )}
            {pdfUrl && (
              <CButton
                color="success"
                href={pdfUrl}
                download={`Report_${objectId}.pdf`}
              >
                <CIcon icon={cilCloudDownload} className="me-2" />
                Скачать PDF
              </CButton>
            )}
          </div>
        </div>

        <div
          className="flex-grow-1 position-relative bg-secondary d-flex align-items-center justify-content-center overflow-hidden"
          style={{ minHeight: "400px" }}
        >
          {isGenerating && (
            <div className="text-center text-white z-index-10">
              <CSpinner color="light" size="lg" className="mb-3" />
              <h4>{progressText}</h4>
              <CProgress
                className="mt-3"
                style={{ width: "300px", height: "20px" }}
              >
                <CProgressBar
                  value={progress}
                  color="info"
                  variant="striped"
                  animated
                >
                  {progress}%
                </CProgressBar>
              </CProgress>
            </div>
          )}

          {error && !isGenerating && (
            <CAlert
              color="danger"
              className="m-4"
              style={{ maxWidth: "600px" }}
            >
              <h5>Ошибка генерации</h5>
              <p>{error}</p>
              <div className="d-flex gap-2 mt-3">
                <CButton
                  color="outline-danger"
                  size="sm"
                  onClick={generateReport}
                >
                  Повторить
                </CButton>
                <CButton color="secondary" size="sm" onClick={onClose}>
                  Закрыть
                </CButton>
              </div>
            </CAlert>
          )}

          {pdfUrl && !isGenerating && (
            <iframe
              src={pdfUrl}
              title="PDF Report"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          )}

          {!pdfUrl && !isGenerating && !error && (
            <div className="text-white-50 text-center">
              <h3>Готов к генерации отчета</h3>
              <p>
                Будут собраны все дефекты, отмеченные на объекте, и их
                заполненные свойства.
              </p>
            </div>
          )}
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Закрыть
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ReportNeuralModule;